import { RoleProps } from "modules/auth/role/store/actionType";

export enum actionTypes {
  //FETCH PERMISSION
  FETCH_PERMISSION_REQUEST = "FETCH_PERMISSION_REQUEST",
  FETCH_PERMISSION_SUCCESS = "FETCH_PERMISSION_SUCCESS",
  FETCH_PERMISSION_FAIL = "FETCH_PERMISSION_FAIL",
  //SER PERMISSION
  SET_PERMISSION_REQUEST = "SET_PERMISSION_REQUEST",
  SET_PERMISSION_SUCCESS = "SET_PERMISSION_SUCCESS",
  SET_PERMISSION_FAIL = "SET_PERMISSION_FAIL",
  //remove permission
  REMOVE_PERMISSION_REQUEST = "REMOVE_PERMISSION_REQUEST",
  REMOVE_PERMISSION_SUCCESS = "REMOVE_PERMISSION_SUCCESS",
  REMOVE_PERMISSION_FAIL = "REMOVE_PERMISSION_FAIL",
  RESET_PERMISSION = "RESET_PERMISSION",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface ActionProp {
  id: string;
  name: string;
  role: [RoleProps];
  action: string;
}
export interface ResourceProp {
  id: string;
  name: string;
  display: string;
  menu: string;
  actions: ActionProp[];
}
export interface ModuleProp {
  display: string;
  id: string;
  menu: string;
  name: string;
  resources: [ResourceProp];
}
export interface PermissionProp {
  action_id: string;
  id: string;
  role_id: string;
  name:string;
  resources: [ResourceProp];
  action?:ActionProp;
}

export interface CreatePermissionInput {
 role_id: string, 
 action_ids: string[]
}

//fetch PERMISSION

export interface FetchPermissionsRequestAction {
  type: actionTypes.FETCH_PERMISSION_REQUEST;
}

export interface FetchPermissionsSuccessAction {
  type: actionTypes.FETCH_PERMISSION_SUCCESS;
  payload: PermissionProp[];
}

export interface FetchPermissionsFailureAction {
  type: actionTypes.FETCH_PERMISSION_FAIL;
  payload: string;
}
//SET PERMISSION

export interface SetPermissionRequestAction {
  type: actionTypes.SET_PERMISSION_REQUEST;
}

export interface SetPermissionSuccessAction {
  type: actionTypes.SET_PERMISSION_SUCCESS;
  payload: PermissionProp[];
}

export interface SetPermissionFailureAction {
  type: actionTypes.SET_PERMISSION_FAIL;
  payload: string;
}
//remove permission

export interface RemovePermissionRequestAction {
  type: actionTypes.REMOVE_PERMISSION_REQUEST;
}

export interface RemovePermissionSuccessAction {
  type: actionTypes.REMOVE_PERMISSION_SUCCESS;
  payload:string;
}

export interface RemovePermissionFailureAction {
  type: actionTypes.REMOVE_PERMISSION_FAIL;
  payload: string;
}
export interface ResetPermission {
  type: actionTypes.RESET_PERMISSION;
}

export type PermissionAction =
  | FetchPermissionsRequestAction
  | FetchPermissionsSuccessAction
  | FetchPermissionsFailureAction
  | SetPermissionRequestAction
  | SetPermissionSuccessAction
  | SetPermissionFailureAction
  | RemovePermissionRequestAction
  | RemovePermissionSuccessAction
  | RemovePermissionFailureAction
  | ResetPermission;
